<template>
  <div class="main">
    <div>
      <es-radio-group v-model="paymentWay" style="width: 100%">
        <ECollapse :active="paymentWay === 'other'">
          <div slot="title">
            <es-radio :label="'other'">{{ $t('使用第三方支付') }}</es-radio>
          </div>
          <div class="e-collapse-content">
            <div class="payment-way">
              <div class="payment-block" :class="{ active: paymentOthWay === 'alipay' }">
                <img src="./../../../assets/payment/Alipay.png" draggable="false" :alt="$t(`支付宝`)" />
              </div>
            </div>
          </div>
        </ECollapse>

        <ECollapse :active="paymentWay === 'Offline'" style="margin-top: 16px">
          <div slot="title">
            <es-radio :label="'Offline'">
              <span>{{ $t('线下转账') }}</span>
              <span v-show="paymentWay === 'Offline'">{{ $t('(您可以通过网银或柜台直接将相应金额转账至e签宝银行账户)') }}</span>
            </es-radio>
          </div>
          <div class="e-collapse-content">
            <ul>
              <li>
                <span>{{ $t('公司名称：') }}</span>
                <span>{{ $t('杭州天谷信息科技有限公司') }}</span>
              </li>
              <li>
                <span>{{ $t('税号：') }}</span>
                <span>913301087458306077</span>
              </li>
              <li>
                <span>{{ $t('地址：') }}</span>
                <span>{{ $t('浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层') }}</span>
              </li>
              <li>
                <span>{{ $t('电话：') }}</span>
                <span>0571-88234700</span>
              </li>
              <li>
                <span>{{ $t('开户银行：') }}</span>
                <span>{{ $t('平安银行杭州高新支行') }}</span>
              </li>
              <li>
                <span>{{ $t('银行账号：') }}</span>
                <span>{{ transferInfo.bankAccountNo || '--' }}</span>
              </li>
            </ul>
          </div>
        </ECollapse>
      </es-radio-group>

      <EButton :width="160" :height="40" @click="surePay">{{ $t('确认支付方式') }}</EButton>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

export default {
  components: {
    ECollapse: () => import('@/components/ECollapse.vue'),
    EButton: () => import('@/components/EButton.vue'),
  },
  data() {
    return {
      paymentOthWay: 'alipay',
      paymentWay: 'other',
      transferInfo: {},
    }
  },
  created() {
    this.getTransferInfo()
  },
  methods: {
    surePay() {
      if (this.paymentWay === 'Offline') {
        this.offline()
      } else {
        this.payInfo()
      }
    },
    // 线下支付
    offline() {
      this.$alert($t('请确认是否选择下线转账，确认后将不能线上支付，同时，也会完成邀请支付'), $t('提示'), {
        confirmButtonText: $t('确定'),
        cancelButtonText: $t('取消'),
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        showClose: false,
      }).then(() => {
        this.$ajax(this.$url.payByTransfer(this.$route.query.invitationId), {}, false)
          .then(res => {
            this.$router.push({
              path: '/invitePayment/result',
              query: {
                invitationId: this.$route.query.invitationId,
              },
            })
          })
          .catch(err => {
            this.$alert(err.message, $t('提示'), {
              confirmButtonText: $t('确定'),
              type: 'error',
              dangerouslyUseHTMLString: true,
              showClose: false,
            }).then(() => {
              window.location.href = 'https://www.esign.cn/'
            })
          })
      })
    },
    // 第三方支付
    async payInfo() {
      const routerData = this.$router.resolve({
        path: '/tempMidPay',
        query: { getThirdPayment: true, invitationId: this.$route.query.invitationId },
      })
      this.safariWindowOpen(routerData.href)
    },
    safariWindowOpen(url) {
      const { userAgent } = navigator
      if (userAgent.indexOf('Safari') > -1) {
        const winRef = window.open('', '_blank')
        winRef.location.href = url
      } else {
        window.open(url)
      }
      this.$router.replace({
        path: '/invitePayment/result',
        query: {
          payOrderId: this.$route.query.payOrderId,
          invitationId: this.$route.query.invitationId,
        },
      })
    },
    thirdPay() {
      const returnUrl = window.location.origin
      const thirdPayMode = 'ALIPAY'

      return this.$ajax(this.$url.payInvitationspagePay(this.$route.query.invitationId), { returnUrl, thirdPayMode }, false).catch(err => {
        this.$alert(err.message, $t('提示'), {
          confirmButtonText: $t('确定'),
          type: 'error',
          dangerouslyUseHTMLString: true,
          showClose: false,
        }).then(() => {
          window.location.href = 'https://www.esign.cn/'
        })
      })
    },
    // 获取转账信息
    getTransferInfo() {
      this.$ajax(this.$url.getTransferInfo(this.$route.query.invitationId), {}).then(res => {
        this.transferInfo = res.data || {}
      })
    },
  },
}
</script>
<style lang="less" scoped>
.e-collapse-content {
  font-size: 14px;
  color: #555b65;
  li {
    margin-top: 10px;
    display: flex;
    span:first-child {
      width: 100px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.main {
  width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
}
.payment-block {
  margin-top: 20px;
  img {
    width: 200px;
    height: 50px;
    border: 1px solid rgba(243, 243, 243, 1);
    background: rgba(255, 255, 255, 1);
  }
}
</style>
